import { useMutation } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useStartConversation() {
  return useMutation({
    mutationFn: async (username: string) => {
      const { data, error } = await supabase.rpc(
        'start_conversation_by_username',
        {
          _target_username: username,
        }
      )
      if (error) throw error
      const result = data as {
        success?: boolean
        error?: string
        conversation_id?: string
      }
      if (result.error) throw new Error(result.error)
      return result
    },
  })
}
